export enum Time {
  DAY = 1,
  WEEK = 7,
  MONTH = 30,
}
